export const CLICK_MORE_TIMES = 'click-more-times';
export const CLICK_NEXT_DAYS = 'click-next-days';
export const CLICK_PREV_DAYS = 'click-prev-days';
export const SHOW_CONSTRAINT = 'show-constraint';
export const CLICK_SLOT = 'click-slot';
export const JUMP_TO_DATE = 'jump-to-date';
export const UPDATE_SELECTED_TIMESLOT = 'update-selected-timeslot';
